<template>
  <hm-content>
    <div class="group-style mb20" v-for="(v,i) in list" :key="i">
      <div class="flex item-center">
        <div class="flex flex-end mr10" style="width: 100px">
          群分类名称
        </div>
        <div class="flex-1 flex item-center">
          <div
              class="mr20"
              style="padding-left: 20px;width: 260px;"
              @dblclick="changeEnddate(i, v)"
          >
                        <span v-show="v.edit_enddate">{{
                            v.categoryName
                          }}</span>
            <el-input
                :ref="'enddateinput' + i"
                @blur="enddateblur(i, v)"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!v.edit_enddate"
                size="small"
                style="width: 260px;"
                v-model="v.categoryName"
                placeholder="请输入分类名称"
            ></el-input>
          </div>
          <!--<el-input
              placeholder="请输入分类名称"
              v-model="v.categoryName"
              style="width: 260px;"
              size="small"
              class="mr20"
              clearable>
          </el-input>-->
          <div
            v-if="i > 0"
            class="flex flex-center"
            style="marginLeft:0"
          >
            <span
                @click="delGroup(v,i)"
                class="hmicon icon-jianhao1 pointer"
                style="font-size: 26px; color: #E50065"
            ></span>
          </div>
        </div>
      </div>
      <div class="flex item-center mt20" style="margin-left: 110px">
        <div class="flex flex-start mr10" style="width: 50px">
          群模板
        </div>
        <div class="flex-1">
          <el-button type="primary" class="add-template" size="small" @click="doAddTemplate(v, i)">+ 添加模板</el-button>
        </div>
      </div>
      <div class="mt20 flex flex-wrap" style="margin-left: 170px">
        <div class="bq-style " v-for="(item, index) in v.templateModelList" :key="index">
          <div class="flex item-center" style="height: 68px">
            <div class="zp mr10">
              <el-image
                  style="width: 42px;height:42px;"
                  :src="item.templatePic"
              ></el-image>
            </div>
            <div>{{item.templateName}}</div>
          </div>
          <div class="temp-btn-wrapper">
            <div class="flex flex-center item-center wrapper">
              <div class="flex flex-around item-center">
                <!-- <el-tooltip class="item" content="设置为首页" placement="top">
                  <el-button
                    @click="setHome(v)"
                    style="color: #0081E5"
                    icon="hmicon icon-home"
                    circle
                  ></el-button>
                </el-tooltip>-->
                <el-tooltip
                    class="item"
                    content="编辑"
                    placement="top"
                    style="color: #0081E5"
                >
                  <el-button
                      @click="editItem(item, v, i)"
                      icon="hmicon icon-bianji"
                      circle
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                    class="item"
                    content="删除"
                    placement="top"
                    style="color: #E50065"
                >
                  <el-button
                      @click="deleteItem(item)"
                      icon="hmicon icon-shanchu"
                      circle
                  ></el-button>
                </el-tooltip>
                <!-- <el-tooltip
                  class="item"

                  content="分享"
                  placement="top"
                  style="color: #0081E5"
                >
                  <el-button icon="hmicon icon-lianjie" circle></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"

                  content="查看"
                  placement="top"
                  style="color: #0081E5"
                >
                  <el-button icon="hmicon icon-chakan" circle></el-button>
                </el-tooltip>-->
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="mt40">
      <el-button type="primary" size="small" style="width: 600px" @click="addGroup">
        添加分类</el-button
      >
    </div>
    <div v-if="addBqVisible">
      <el-drawer
          title="活动基本信息"
          :wrapperClosable="false"
          :visible.sync="addBqVisible"
          direction="rtl"
          :before-close="resetForm"
          custom-class="demo-drawer"
          ref="drawer"
      >
        <div class="demo-drawer__content">
          <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
            <el-form-item label="模板名称" >
              <el-input v-model="ruleForm.templateName" clearable size="small" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="模板解释" >
              <el-input v-model="ruleForm.templateDesc" clearable size="small" placeholder="请输入模板解释"></el-input>
            </el-form-item>
            <el-form-item label="模板图标" >
              <div v-if="ruleForm.templatePic" class="flex">
                <div class="mr10 flex item-end priview">
                  <el-image
                      class="img"
                      style="width: 106px; height: 106px"
                      :src="ruleForm.templatePic"
                      alt="logo"
                      :preview-src-list="[ruleForm.templatePic]"
                  />
                  <div
                      class="opreat-wrapper flex item-center flex-center"
                  >
                    <el-button type="text" @click="handleRemove('templatePic')"
                    >删除</el-button
                    >
                  </div>
                </div>
              </div>
              <el-upload
                  v-else
                  class="upload flex"
                  ref="upload"
                  :data="{ fileDir: 'mall' }"
                  :headers="{ 'X-Access-Token': $token }"
                  :action="$uploadUrl"
                  :onError="uploadError"
                  :onSuccess="uploadSuccess"
                  :beforeUpload="beforeAvatarUpload"
                  :onProgress="uploading"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                    <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                    ></span>
                    </div>
                    <span class="gray">更换图标</span>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="选择人群" >
              <el-button size="small" type="primary" @click="doSelectBq">添加标签</el-button>
              <div style="color: #999999;font-size: 14px">已选</div>
              <div class="flex flex-wrap">
                <div class="addBq flex flex-center item-center" v-for="(v,i) in ruleForm.templateTagCalcValue" :key="i">
                  <div>{{ v.calcValue }}</div>
                  <div class="guanBi hmicon icon-jujue" @click="delBq(i)"></div>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="btn-wrapper flex flex-center mt20">
            <el-button size="small" type="primary" :loading="loading.templateLoading" @click="submitGroupTemplate">确 认</el-button>
          </div>
        </div>
      </el-drawer>
    </div>

    <el-dialog
        title="添加分类"
        :visible.sync="addGroupVisible"
        :close-on-click-modal="false"
        width="600px"
    >
      <el-form :model="groupForm" :rules="rules" ref="groupForm" label-width="100px">
        <el-form-item label="群分类名称" prop="groupName">
          <el-input v-model="groupForm.groupName" size="small" placeholder="请输入群分类名称" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" :loading="loading.groupLoading" @click="submitGroup">
          确认</el-button
        >
        <el-button type="info" size="small" @click="addGroupVisible = false">
          取消</el-button
        >
      </div>
    </el-dialog>

    <div v-if="addSelectBqVisible">
      <el-dialog
          title="选择标签"
          :visible.sync="addSelectBqVisible"
          :close-on-click-modal="false"
          width="800px"
      >
        <span style="color: #999999">选择多个标签是且的关系</span>
        <div class="mt20 flex">
          <div class="cy-bq">
            <el-scrollbar wrap-style="height: 401px;">
              <el-menu
                  :default-active="defaultActive"
                  @select="checkCyBq"
                  background-color="#F7F7F7"
                  class="el-menu-vertical-demo"
              >
                <el-menu-item class="text-center" v-for="(v,i) in cyBqList" :key="i" :index="i.toString()">
                  <span slot="title">{{ v.catName }}</span>
                  <div v-show="v.active" class="active-cy-bq"></div>
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </div>
          <div class="flex-1">
           <!-- <div class="flex flex-end item-center">
              <el-input v-model="searchCondition.tagName" clearable size="small" placeholder="请输入标签名称查询" class="mr20" ></el-input>
              <el-button size="small" type="primary" @click="queryBqList">查询</el-button>
            </div>-->
            <el-scrollbar wrap-style="height: 500px;">
              <div class="flex flex-wrap " style="margin-top: 30px;">
                <div class="bqList-style flex flex-column flex-around" v-for="(v,i) in bqList" :key="i"  @click="doSelected(v, i)" :class="v.selected ? 'bqList-select-style' : 'bqList-not-select-style'">
                  <div class="flex item-center">
                    <div
                        class="flex flex-center"
                        style="marginLeft:0;margin-right: 5px"
                        v-if="!v.selected"
                    >
            <span
                class="hmicon icon-weixuanzhong pointer"
            ></span>
                    </div>
                    <div
                        class="flex flex-center"
                        style="marginLeft:0;margin-right: 5px;color: #e50065;"
                        v-else

                    >
            <span
                class="hmicon icon-xuanzhong pointer"
            ></span>
                    </div>
                    <div>{{ v.calcValue }}</div>
                  </div>
                  <div style="font-size: 12px; color: #999999">{{ v.comments }}</div>
                </div>
              </div>
            </el-scrollbar>
            <!--<div style="margin-top: 50px">
              <el-button size="small" class="orange-bg cs" >测试</el-button>
            </div>
            <div class="mt20">
              <el-table
                  :data="tableData"
                  border
                  stripe
                  size="small"
                  style="width: 95%">
                <el-table-column
                    prop="date"
                    label="客户数"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="导购数"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="address"
                    header-align="center"
                    align="center"
                    label="占比">
                  <template >
                    <div  class="gray" style="width:50px">
                      &#45;&#45; &#45;&#45;
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>-->
          </div>
        </div>
        <div slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button type="primary" size="small" @click="submitSelectBq">
            确认</el-button
          >
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      list: [
          {
        name: "",
        templateModelList:[]
      }
      ],
      defultImg: "https://imgcdn.hemiao100.com/ThemePictures/lQLPDhqq_2MDIS1UVLDUu8qI54PtpVFP5iyFUtKa_84_84.png_720x720q90g.jpg",
      addBqVisible: false,
      ruleForm: {
        templateName: "",
        templateDesc: "",
        templatePic: "",
        templateTagCalcValue: []
      },
      bqList: [],
      addSelectBqVisible: false,
      tableData: [],
      cyBqList: [],
      defaultActive: "0",
      selectList: [],
      row: {},
      rowIndex: 0,
      templateType: "add",
      addGroupVisible: false,
      rules: {
        groupName: [
          { required: true, message: '请输入群分类名称', trigger: 'blur' },
        ]
      },
      groupForm: {
        groupName: ""
      },
      loading: {
        groupLoading: false,
        templateLoading: false
      },
      templateRow: {},
      selectCyBqRow: {},
      editwxName: ""
    };
  },
  created() {
    this.queryList();
  },
  mounted() {},
  methods: {
    changeEnddate(index, rowdata) {
      this.editwxName = rowdata.categoryName;
      this.list[index].edit_enddate = !this
          .list[index].edit_enddate; //直接加key
      this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index][0].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur(index, rowdata) {
      if (
          rowdata.categoryName === "" ||
          rowdata.categoryName === this.editwxName
      ) {
        rowdata.categoryName = this.editwxName;
        this.list = [...this.list];
      } else {
        let params = {
          categoryName: rowdata.categoryName,
          categoryId: rowdata.categoryId
        };
        this.$store.dispatch("editWechatGroupCategoryName", params).then(res => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.queryList();
          }
        });
      }
      this.list[index].edit_enddate = !this
          .list[index].edit_enddate;
    },
    //查询标签
    async queryBqList() {
      this.bqList = [];
      const { storeCode } = getLoginUser();
      let params = {
        tagCat: this.selectCyBqRow.id,
        storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });

      const { code, result } = await this.$store.dispatch('queryCustomerBaseBqList', formData);
      if (code === "0") {
        let bqList = [];
        result.tags.forEach(v => {
          v.calcValues.forEach(item =>{
            let haveSelected = this.ruleForm.templateTagCalcValue.some(bq => {
              if (bq.tagKey == v.tagKey && bq.calcValue == item.calcValue) {
                return true;
              } else {
                return false;
              }
            });
            let select = this.selectList.some(bq => {
              if (bq.tagKey == v.tagKey && bq.calcValue == item.calcValue) {
                return true;
              } else {
                return false;
              }
            });
            let selected = haveSelected || select;
            bqList.push({
              tagCat: v.tagCat,
              tagKey: v.tagKey,
              tagNameL: v.tagName,
              comments: item.comments,
              calcValue: item.calcValue,
              selected: selected
            });
          });
        });
        this.bqList = bqList;
      }
    },
    //模板删除
    deleteItem(item) {
      this.$confirm("是否删除该模板", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.$store
                .dispatch("delCustomerBaseTemplateInfo", {
                  templateId: item.templateId
                })
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: " 删除成功",
                      type: "success"
                    });
                    this.queryList();
                  }
                });
          })
          .catch(err => {
            throw new Error(err);
          });
    },
    //查询模板信息
    async queryTemplateInfo() {
      let params = {
        templateId: this.templateRow.templateId
      };
      const { code, result } = await this.$store.dispatch('queryCustomerBaseTemplateInfo', params);
      if (code === "0") {
        result.templateTagCalcValue = JSON.parse(result.templateTagCalcValue);
        console.log("result", result);
        this.ruleForm = result;
      }
    },
    //编辑模板
    editItem(item, parentItem, index) {
      this.row = parentItem;
      this.rowIndex = index;
      this.templateRow = item;
      this.templateType = "edit";
      this.addBqVisible = true;
      this.queryTemplateInfo();
    },
    //提交群分类
    submitGroup() {
      this.loading.groupLoading = true;
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          let params = {
            categoryName: this.groupForm.groupName
          };
          this.$store.dispatch('addCustomerBaseGroup', params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.loading.groupLoading = false;
              this.addGroupVisible = false;
              this.queryList();
            }
          });
        } else {
          this.loading.groupLoading = false;
          return false;
        }
      });
    },
    //提交分组模板
    submitGroupTemplate() {
      this.loading.templateLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.templateType == "add") {
            let templateModel = JSON.parse(JSON.stringify(this.ruleForm));
            templateModel.templateTagCalcValue = JSON.stringify(this.ruleForm.templateTagCalcValue);
            let params = {
              categoryId: this.row.categoryId,
              templateModelList:  [templateModel]
            };
            this.$store.dispatch('addCustomerBaseTemplateInfo', params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.addBqVisible = false;
                this.initRuleForm();
                this.loading.templateLoading = false;
                this.queryList();
              } else {
                this.loading.templateLoading = false;
              }
            })
          } else {
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.templateTagCalcValue = JSON.stringify(this.ruleForm.templateTagCalcValue);
            this.$store.dispatch('editCustomerBaseTemplateInfo', params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.addBqVisible = false;
                this.initRuleForm();
                this.loading.templateLoading = false;
                this.queryList();
              } else {
                this.loading.templateLoading = false;
              }
            });
          }
        } else {
          this.loading.templateLoading = false;
          return false;
        }
      });
    },
    //删除群分类
    delGroup(item, index) {
      this.$confirm("是否删除该分组", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.$store
                .dispatch("delCustomerBaseGroup", {
                  categoryId: item.categoryId
                })
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: " 删除成功",
                      type: "success"
                    });
                    this.queryList();
                  }
                });
          })
          .catch(err => {
            throw new Error(err);
          });
    },
    //添加群分类
    addGroup() {
      this.addGroupVisible = true;
      this.$nextTick(() => {
        this.$refs.groupForm.resetFields();
      });
     /* this.list.push({
        name: "",
        bq:[]
      });*/
    },
    //初始化ruleForm
    initRuleForm() {
      this.ruleForm = {
        templateName: "",
        templateDesc: "",
        templatePic: "",
        templateTagCalcValue: []
      };
    },
    //重置表单
    resetForm(done) {
      this.$nextTick(() => {
        this.initRuleForm();
        done();
      });
    },
    //添加模板
    doAddTemplate(item, index) {
      this.row = item;
      this.rowIndex = index;
      this.templateType = "add";
      this.addBqVisible = true;
    },
    //选择标签
    async doSelectBq() {
      this.addSelectBqVisible = true;
      const { storeCode } = getLoginUser();
      let params = {
        queryType: "user",
        fromType: "group",
        tenantId: storeCode
      };
      const { result } = await this.$store.dispatch('queryAllTagCat', params);
      result.forEach((v,i) => {
        if (i == this.defaultActive) {
          this.selectCyBqRow = v;
          v.active = true;
        } else {
          v.active = false;
        }
      });
      this.cyBqList = result;
      await this.queryBqList();

    },
    //确认添加选择标签
    submitSelectBq() {
      this.ruleForm.templateTagCalcValue = JSON.parse(JSON.stringify(this.selectList));
      this.addSelectBqVisible = false;
    },
    checkCyBq(index) {
      this.cyBqList.forEach((v,i) => {
        if (i == index) {
          this.selectCyBqRow = v;
          v.active = true;
        } else {
          v.active = false;
        }
      });
      this.queryBqList();
    },
    doSelected(item, index) {
      let val = !item.selected;
      item.selected = val;
      if (val) {
        this.selectList.push(item);
      } else {
        this.selectList.splice(index, 1);
      }
    },
    //删除标签
    delBq(index) {
      this.ruleForm.templateTagCalcValue.splice(index, 1);
    },
    uploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.templatePic = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      //   this.isSaving = false;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpeg";
      const extension3 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
    async queryList() {
      const { storeCode } = getLoginUser();
      const params = {
        storeCode
      };
      const { code, result } = await this.$store.dispatch("queryCustomerBaseGroupList", params);
      if (code === "0") {
        result.forEach(v => {
          v.edit_enddate = true;
        });

        this.list = result;
        console.log("list", this.list);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bq-style {
  width: 159px;
  height: 68px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 0px 10px;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;
  .zp {
    width: 42px;
    height: 42px;
    background: #D8D8D8;
    border-radius: 2px;
  }
  &:hover {
    .temp-btn-wrapper {
      display: block;
    }
  }
  .temp-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 68px;
/*    height: 394px;
    padding-left: 35px;*/
    display: none;
    background: rgba(0, 0, 0, 0.4);
    .wrapper {
      height: 100%;
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    margin-left: 0;
    // padding: 10px;
    margin-right: 10px;
    width: 106px;
    height: 106px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  width: 106px;
  height: 106px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.addBq {
  width: 156px;
  height: 44px;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  margin-right: 30px;
  margin-bottom: 20px;
  position:relative;
  .guanBi {
    position: absolute;
    right: -8px;
    top: -20px;
    z-index: 99999;
    &.guanBi::before {
      background-color: #AAAAAA;
      border-radius: 50%;
      font-size: 18px;
      color: #fff;
    }
  }
}
.cy-bq {
  width: 146px;
  height: 401px;
  background: #F7F7F7;
  border-radius: 4px;
  margin-right: 30px;
  .text-center {
    position: relative;
    .active-cy-bq {
      position: absolute;
      width: 4px;
      height: 44px;
      background: #E50065;
      right: 0px;
      bottom: 0px;
    }
  }

}
.bqList-style {
  width: 150px;
  height: 68px;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 0px 10px;
}
.bqList-not-select-style {
  border: 1px solid #DDDDDD;
}
.bqList-select-style {
  background: rgba(254, 222, 236, 0.5);
  border: 1px solid #E50065;
}
.cs {
  color: #fff;
  border: 1px solid #FF7F10;
}
.add-template {
  width: 106px;
  height: 44px;
  border-radius: 6px;
  color: #E50065;
  font-size: 14px;
  background-color: #fff;
  border: 1px solid #E50065;
}
.group-style {
  border-radius: 6px;
  border: 1px solid #F4F4F4;
  padding: 30px 0px;
}
</style>
